module.exports = __webpack_public_path__ + "img/apple-logo.32b98926.svg";